import { render, staticRenderFns } from "./SeventhStep.vue?vue&type=template&id=38481221&"
import script from "./SeventhStep.vue?vue&type=script&lang=js&"
export * from "./SeventhStep.vue?vue&type=script&lang=js&"
import style0 from "./SeventhStep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports